module.exports = __webpack_public_path__ + "img/PayamIbrahim.e74453e6.jpg";